<template>
  <div class="comingsoon homes-page" v-if="client">
    <div class="side">
      <img @click="goTo('/')" class="logo" :src="client.logo" />
      <h2>{{ new_homes_page ? new_homes_page.title : "New Homes" }}</h2>
      <p>{{ new_homes_page ? new_homes_page.description : "Home Listings" }}</p>
      <div class="navs">
        <div
          class="nav"
          :style="{
            backgroundColor:
              client.color && client.color.primary
                ? '#' + client.color.primary
                : '#F26638',
          }"
          @click="goTo('/legacyhomes')"
        >
          <p>Legacy Homes</p>
          <img src="@/assets/img/next.svg" />
        </div>
        <div
          class="nav"
          :style="{
            backgroundColor:
              client.color && client.color.primary
                ? '#' + client.color.primary
                : '#F26638',
          }"
          @click="goTo('/build')"
        >
          <p>Build A Home</p>
          <img src="@/assets/img/next.svg" />
        </div>
      </div>
    </div>
    <template v-if="listings && listings.length">
      <div class="gallery">
        <div
          v-for="(item, i) in listings"
          @click="moreDetails(item)"
          :class="item.images ? '' : 'missing'"
          class="image"
          :style="{
            backgroundImage:
              'url(' +
              (item.images
                ? item.images[0]
                : require('@/assets/img/no-photo.svg')) +
              ')',
          }"
        ></div>
      </div>
    </template>
    <template v-if="!listings || (listings && !listings.length)">
      <div class="gallery no-listings">
        <img src="@/assets/img/no-photo.svg" />
        <p>There are currently no new listings</p>
      </div>
    </template>

    <transition name="fade">
      <div class="home-details" v-if="selected_home">
        <div class="close" @click="selected_home = null">
          <img src="@/assets/img/close.svg" />
          <p>close</p>
        </div>
        <div class="offclick" @click="selected_home = null"></div>
        <div class="details">
          <div class="images">
            <div
              class="main"
              :style="{
                backgroundImage:
                  'url(' +
                  (selected_home.images
                    ? selected_home.images[selected_image]
                    : '') +
                  ')',
              }"
            ></div>
            <div class="gallery">
              <template v-if="selected_home.images">
                <div
                  class="image"
                  v-for="(image, i) in selected_home.images"
                  :class="{ active: selected_image == i }"
                  @click="selected_image = i"
                  :style="{
                    backgroundImage: 'url(' + selected_home.images[i] + ')',
                  }"
                ></div>
              </template>
              <div class="fade"></div>
            </div>
          </div>
          <div class="text">
            <div class="text-box">
              <h2>{{ selected_home.headline }}</h2>
              <div
                class="facts"
                v-if="
                  selected_home.price &&
                    selected_home.square_footage &&
                    selected_home.bedrooms &&
                    selected_home.bathrooms
                "
              >
                <p class="fact">
                  Price
                  <span
                    >${{
                      formatPrice(parseInt(selected_home.price).toFixed(2))
                    }}</span
                  >
                </p>
                <p class="fact">
                  SQ. FT
                  <span>{{
                    formatPrice(parseInt(selected_home.square_footage))
                  }}</span>
                </p>
                <p class="fact">
                  Bedrooms
                  <span>{{ parseInt(selected_home.bedrooms).toFixed(1) }}</span>
                </p>
                <p class="fact">
                  Bathrooms
                  <span>{{
                    parseInt(selected_home.bathrooms).toFixed(1)
                  }}</span>
                </p>
              </div>
              <p>{{ selected_home.subhead }}</p>
              <p>{{ selected_home.description }}</p>
            </div>
            <div class="fade"></div>
            <div class="navs">
              <div
                @click="contactPopup = true"
                class="nav"
                :style="{
                  backgroundColor:
                    client.color && client.color.primary
                      ? '#' + client.color.primary
                      : '#F26638',
                }"
              >
                <p>Contact</p>
                <img src="@/assets/img/next.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <contact-popup
      :contactPopup="contactPopup"
      :selected_home="selected_home"
      pageName="New Homes"
    ></contact-popup>
  </div>
</template>

<script>
import { db, functions, analytics } from "@/config/firebaseInit";
import axios from "axios";
import ContactPopup from "@/components/ContactPopup";
var parseString = require("xml2js").parseString;

export default {
  name: "home",
  components: {
    "contact-popup": ContactPopup,
  },
  data() {
    return {
      client: this.$store.state.client,
      user: this.$store.state.user,
      generic_images: this.$store.state.generic_images,
      new_homes_page: this.$store.state.new_homes_page,
      selected_home: null,
      selected_image: 0,
      properties: null,
      propertyMedia: null,
      listings: this.$store.state.newHomes,
      contactPopup: false,
    };
  },
  created() {
    if (this.listings) {
      this.listings.forEach((listing) => {
        if (!listing.images) {
          listing.images = this.getRandomGenericImages();
        }
      });
    }
  },
  watch: {},
  methods: {
    formatPrice(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    moreDetails(home) {
      this.selected_image = 0;
      this.selected_home = home;
    },
    getRandomGenericImages() {
      if (this.generic_images.images.length >= 4) {
        let images = this.generic_images.images.map((image) => {
          return image.url;
        });
        for (let i = images.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * i);
          const temp = images[i];
          images[i] = images[j];
          images[j] = temp;
        }
        return images.slice(0, 3);
      }
    },
  },
};
</script>

<style lang="scss">
.comingsoon {
  height: 100vh;
  width: 100vw;
  display: flex;
  .side {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 500px;
    padding: 100px;
    background: white;
    min-height: 100vh;
    flex: none;
    .logo {
      width: 275px;
      margin: auto;
      margin-top: 50px;
      margin-bottom: 30px;
    }
    h2 {
      color: black;
      font-size: 51px;
      margin-bottom: 0;
    }
    p {
      font-size: 23px;
    }
  }
  .gallery {
    display: flex;
    justify-content: flex-start !important;
    flex-wrap: wrap;
    width: 100%;
    padding: 30px;
    max-height: 1080px;
    overflow: hidden;
    overflow-y: auto;
    background: #f7f7f7;
    .image {
      width: 31.5% !important;
      margin-right: 1.75%;
      height: 323px;
      margin-bottom: 25px;
      background-size: cover;
      background-repeat: no-repeat;
      &.missing {
        background-color: #eaeaea;
        background-size: 100px;
        background-position: center center;
      }
    }
    &.no-listings {
      display: flex;
      justify-content: center !important;
      align-items: center;
      flex-direction: column;
      background: #f7f7f7;
      img {
        height: 150px;
        opacity: 0.2;
      }
      p {
        margin-top: 50px;
        font-size: 40px;
        font-weight: bold;
        max-width: 400px;
        text-align: center;
      }
    }
  }

  .home-details {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 150px;
    .offclick {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .details {
      position: relative;
      z-index: 3;
      width: 100%;
      height: 100%;
      display: flex;
      background: white;
      padding: 75px;
      .images {
        width: 60%;
        position: relative;
        .main {
          width: 100%;
          height: 500px;
          background-size: contain;
          background-color: black;
          background-repeat: no-repeat;
          background-position: center center;
        }
        .gallery {
          display: flex;
          padding: 0;
          margin-top: 30px;
          justify-content: flex-start;
          flex-wrap: nowrap;
          overflow: hidden;
          overflow-x: auto;
          padding-right: 50px;
          .image {
            flex: none;
            width: 100px;
            height: 100px;
            margin-right: 20px;
            overflow: hidden;
            overflow-x: auto;
            &.active {
              opacity: 0.3;
            }
          }
        }
        .fade {
          pointer-events: none;
          position: absolute;
          right: 0;
          height: 100px;
          width: 100px;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1)
          );
        }
      }
      .text {
        width: 40%;
        padding: 50px;
        padding-left: 100px;
        display: flex;
        flex-direction: column;
        padding-bottom: 0;
        position: relative;
        .text-box {
          max-height: 455px;
          overflow: hidden;
          overflow-y: auto;
          padding-bottom: 50px;
        }
        .fade {
          pointer-events: none;
          position: absolute;
          right: 0;
          top: 405px;
          height: 100px;
          width: 100%;
          background: linear-gradient(
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1)
          );
        }
        h2 {
          color: black;
          font-size: 40px;
          margin-top: 0;
        }
        .facts {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-bottom: 25px;
          .fact {
            font-size: 20px;
            width: 50%;
            display: flex;
            flex-direction: column;
            font-weight: bold;
            padding-right: 50px;
            margin-bottom: 0;
            span {
              font-weight: normal;
            }
          }
        }
      }
    }
  }
}
.homes-page {
  align-items: flex-start;
  background: #f7f7f7;
}
</style>
